import axios from 'axios'

export default class ViaCepService {
  static async getEnderecoByCep(cep) {
    return axios.get(`https://viacep.com.br/ws/${cep}/json/`).then(res => res.data)
  }
}
